import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import Pagination from '../../../Pagination';
import { flightSearch } from '../../../../store/slices/flight';
import { SearchModes } from '../../../../constants';

const FlightPagination = ({ tripId }) => {
  const flightSearchState = useSelector((store) => store.flight.flightSearches[tripId]);
  const dispatch = useDispatch();
  const responses = useSelector((state) => state.flight.responses);
  const [response, setResponse] = useState(null);

  // TODO: useCallback?
  useEffect(() => {
    if (flightSearchState && responses) {
      setResponse(responses[flightSearchState.queryString]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flightSearchState]);

  const handleNextPageClick = () => {
    const { page, pageSize } = flightSearchState.searchObj;
    const { totalFlights } = response;
    const p = (page * pageSize) + (totalFlights % pageSize) > totalFlights ? page : page + 1;

    if (p > page) {
      dispatch(flightSearch({
        tripId,
        searchObj: {
          page: p,
        },
      }));
    }
  };

  const handlePrevPageClick = () => {
    const { searchObj: { page } } = flightSearchState;
    const p = page - 1 > 0 ? page - 1 : page;
    if (p < page) {
      dispatch(flightSearch({
        tripId,
        searchObj: {
          page: p,
        },
      }));
    }
  };

  return (
    flightSearchState
      ? (
        <Pagination
          page={flightSearchState.searchObj.page}
          pageSize={flightSearchState.searchObj.pageSize}
          totalCount={(response || {}).totalFlights}
          onPrevPageClick={handlePrevPageClick}
          onNextPageClick={handleNextPageClick}
          resultsLabel="flights"
          searchMode={SearchModes.FLIGHT}
        />
      ) : ''
  );
};

FlightPagination.propTypes = {
  tripId: PropTypes.string.isRequired,
};

export default FlightPagination;
